import { NotificationTemplateTypes } from '@ui/src';

export interface NotificationCenterFilters {
  category?: string[];
  group: string[];
  type: string[];
  status: string[];
  responsibleId: string[];
  executorId: string[];
  createdAt?: string[];
  createdAtFrom: string;
  createdAtTo: string;
  deadline?: string[];
  deadlineFrom: string;
  deadlineTo: string;
}

export interface Notification {
  id: string;
  categoryId: string;
  groupId: string;
  actionId: string;
  createdAt: string;
  readAt?: string;
  status: string;
  executorId?: string;
  responsibleId?: string;
  deadlineAt?: string;
}

export interface EditNotificationsValues {
  status?: string;
  responsibleId?: string;
  executorId?: string;
  deadline?: string;
  comment?: string;
  ids?: string[];
}

export enum NotificationCategoryEnum {
  MESSAGING = 'MESSAGING',
  TRANSACTIONS = 'TRANSACTIONS',
  CUSTOMERS = 'CUSTOMERS',
  REPORTS = 'REPORTS',
  ISSUES = 'ISSUES',
  CUSTOMERS_AND_MESSAGING = 'CUSTOMERS_AND_MESSAGING',
}

export enum NotificationGroupEnum {
  MESSAGING_CHANNEL = 'MESSAGING_CHANNEL',
  CUSTOMERS_CORPORATE = 'CUSTOMERS_CORPORATE',
  CUSTOMERS_INDIVIDUAL = 'CUSTOMERS_INDIVIDUAL',
  CUSTOMERS_APPLICATION = 'CUSTOMERS_APPLICATION',
  ISSUES = 'ISSUES',
  TRANSACTIONS_INCOMING = 'TRANSACTIONS_INCOMING',
  TRANSACTIONS_OUTGOING = 'TRANSACTIONS_OUTGOING',
  TRANSACTIONS_INTERNAL = 'TRANSACTIONS_INTERNAL',
  TRANSACTIONS_EXCHANGE = 'TRANSACTIONS_EXCHANGE',
  TRANSACTIONS_NOSTRO = 'TRANSACTIONS_NOSTRO',
  TRANSACTIONS_CASH_COLLECTION = 'TRANSACTIONS_CASH_COLLECTION',
}

export enum NotificationEntityType {
  AGREEMENT = 'AGREEMENT',
  DOCUMENT = 'DOCUMENT',
  OFFICIALS = 'OFFICIALS',
  APPLICATION = 'APPLICATION',
  NOTIFICATION = 'NOTIFICATION',
  ORGANIZATION = 'ORGANIZATION',
  CHANNEL = 'CHANNEL',
  TRANSACTION = 'TRANSACTION',
  WARNING_GROUP = 'WARNING_GROUP',
  CLIENT_SCORE_RESULT = 'CLIENT_SCORE_RESULT',
  ISSUE = 'ISSUE',
  PAYMENT_ORDER = 'PAYMENT_ORDER',
  LOCK = 'LOCK',
}

export enum NotificationItemIssueStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  CANCELED = 'CANCELED',
}

export interface NotificationItemIssue {
  notificationId: string;
  responsibleId?: string;
  executorId?: string;
  deadline?: string;
  status?: NotificationItemIssueStatus;
  executor?: {
    id: string;
    profile: {
      firstName: string;
      lastName: string;
    };
  };
  responsible?: {
    id: string;
    profile: {
      firstName: string;
      lastName: string;
    };
  };
  id?: string;
  createdAt: string;
}

export interface NotificationItem {
  category: NotificationCategoryEnum;
  group: NotificationGroupEnum;
  type: NotificationTemplateTypes;
  entityType: NotificationEntityType;
  entityId: string;
  employeeId?: string;
  organizationId?: string;
  organization?: {
    id: string;
    type: string;
    firstName?: string;
    lastName?: string;
    companyName?: string;
  };
  issue?: NotificationItemIssue;
  employee?: {
    id: string;
    profile: {
      firstName: string;
      lastName: string;
    };
  };
  id: string;
  createdAt?: string;
}

export interface NotificationItemComment {
  content: string;
  createdAt: string;
  id: string;
  issueId: string;
  updatedAt: string;
  user: {
    profile: {
      firstName: string;
      lastName: string;
    };
  };
}
